import { useEffect } from "react";
import { firestore } from "../firebase/firebase";
import { isIOS } from "./deviceDetection";

// iOS freezes the tab on background and kills Firestore's single Listen stream.
// The SDK only reconnects on its own exponential backoff (up to ~60s) and never
// resets it on tab-resume, so listeners look live but deliver nothing. On resume
// we force an immediate reconnect by toggling the network — safe here because iOS
// is pinned to forced long-polling, so this can't corrupt auto-detect (#7686).
const RECONNECT_THROTTLE_MS = 3000;

export const useIosFirestoreReconnect = () => {
  useEffect(() => {
    if (!isIOS()) return undefined;

    let lastKick = 0;
    const reconnect = async () => {
      const now = Date.now();
      if (now - lastKick < RECONNECT_THROTTLE_MS) return; // ignore duplicate resume events
      lastKick = now;
      try {
        await firestore.disableNetwork();
      } catch (e) {
        // ignore — still attempt to re-enable below so we never stick offline
      }
      try {
        await firestore.enableNetwork();
      } catch (e) {
        console.error("Firestore reconnect failed:", e);
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") reconnect();
    };
    const onPageShow = (event) => {
      if (event.persisted) reconnect(); // bfcache restore
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("online", reconnect);

    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("online", reconnect);
    };
  }, []);
};
